/**
 * KikTheme.analytics — theme-wide dataLayer helper.
 * Ecommerce events use the Zephyr `s_` prefix; custom events are unprefixed.
 */
(() => {
  window.KikTheme = window.KikTheme || {};
  if (window.KikTheme.analytics) return;

  const toNumber = (value) => {
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
  };

  const analytics = {
    eventPrefix: 's_',

    track(name, params = {}) {
      if (!name) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({ event: name, ...params });
    },

    trackEcommerce(name, payload = {}) {
      if (!name) return;
      window.dataLayer = window.dataLayer || [];
      const items = Array.isArray(payload.items) ? payload.items : [];
      const value =
        payload.value != null
          ? toNumber(payload.value)
          : items.reduce((sum, item) => sum + toNumber(item.price) * (item.quantity || 1), 0);

      const ecommerce = {
        currency: payload.currency,
        value: +value.toFixed(2),
        items,
      };
      if (payload.item_list_id) ecommerce.item_list_id = payload.item_list_id;
      if (payload.item_list_name) ecommerce.item_list_name = payload.item_list_name;

      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({ event: this.eventPrefix + name, ecommerce });
    },

    mapItem(raw = {}, extra = {}) {
      const price = raw.priceAmount != null ? raw.priceAmount : raw.price;
      const item = {
        item_id: String(raw.sku || raw.item_id || ''),
        item_name: raw.title || raw.item_name || raw.product_title || '',
        price: +toNumber(price).toFixed(2),
        quantity: raw.quantity || 1,
      };

      const productId = raw.id != null ? raw.id : raw.product_id;
      const variantId = raw.variantId != null ? raw.variantId : raw.variant_id;
      if (productId != null && productId !== '') item.product_id = String(productId);
      if (variantId != null && variantId !== '') item.variant_id = String(variantId);
      if (raw.vendor || raw.item_brand) item.item_brand = raw.vendor || raw.item_brand;
      if (raw.type || raw.item_category) item.item_category = raw.type || raw.item_category;

      const index = extra.index != null ? extra.index : raw.index;
      const listId = extra.item_list_id || raw.item_list_id;
      const listName = extra.item_list_name || raw.item_list_name;
      if (index != null) item.index = index;
      if (listId) item.item_list_id = String(listId);
      if (listName) item.item_list_name = listName;
      return item;
    },
  };

  const bindDeclarativeClicks = () => {
    if (document.documentElement.dataset.kikAnalyticsBound === 'true') return;
    document.documentElement.dataset.kikAnalyticsBound = 'true';
    document.addEventListener(
      'pointerdown',
      (event) => {
        const el = event.target.closest('[data-analytics-event]');
        if (!el) return;
        const name = el.getAttribute('data-analytics-event');
        if (!name) return;
        const params = {};
        Array.from(el.attributes).forEach((attr) => {
          if (!attr.name.startsWith('data-analytics-') || attr.name === 'data-analytics-event') return;
          const key = attr.name
            .slice('data-analytics-'.length)
            .replace(/-([a-z])/g, (_, char) => char.toUpperCase());
          params[key] = attr.value;
        });
        analytics.track(name, params);
      },
      true
    );
  };

  bindDeclarativeClicks();
  window.KikTheme.analytics = analytics;
})();
